import React, { Component } from 'react'
import Select from 'react-select'
import axios from 'axios'
import swal from 'sweetalert'
import DatePicker from 'react-datetime';
import moment from 'moment';
import ls from 'local-storage'
import 'react-datetime/css/react-datetime.css';

export class Tenderapproval extends Component {
    constructor(props){     
        super(props);
        this.state = {
            errors: {},
            appstatuslist:[],
            partworkdtpmaster:[],
            age_excess_allowd:[],
            invitiongtenderslist:[],
            submitinvitiongtenderslist:[],
            formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode},
                       
        };
        this.hideComponent = this.hideComponent.bind(this);
        this.selecthandleChange = this.selecthandleChange.bind(this);
        this.datepickerhandleChange = this.datepickerhandleChange.bind(this);
      }    
      componentDidMount() {
        document.title = "DTP"
        const Axios = axios.create({
          baseURL: process.env.REACT_APP_API_URL,
        });
        this.getdataafterload();
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;     
        Axios.get(`${process.env.REACT_APP_API_URL}partworks/getappstatus`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.aastatuscd,
              "label" : d.aastatusdesc           
            }))    
            this.setState({appstatuslist: options})  
          }           
        });  
        Axios.get(`${process.env.REACT_APP_API_URL}master/getagency`)
        .then(result=>{
          if(result.status === 200){
            const options = result.data.map(d => ({
              "value" : d.agencyid,
              "label" : d.agencyname           
            }))    
            this.setState({agencylist: options})  
          }           
        });                       
      } 
      async getdataafterload()
      {
        const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
        });
        const loginToken = ls.get('loginToken');
        Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;           
        Axios.post(`${process.env.REACT_APP_API_URL}partworks/invitingtenders`, this.props.children)
        .then(result=>{
          if(result.status === 200){
            this.setState({partworkdtpmaster:result.data.partworkdtpmaster});                      
            this.setState({age_excess_allowd:result.data.age_excess_allowd});                      
            this.setState({invitiongtenderslist:result.data.invitiongtenderslist});                    
            this.setState({submitinvitiongtenderslist:result.data.submitinvitiongtenderslist});                    
          }      
        }); 
      }         
      hideComponent(e) { 
        let formdetails = this.state.formdetails;
        formdetails[e.target.name] = e.target.value;  
        this.setState({formdetails});
     }     
     handleValidation(){
        let formdetails = this.state.formdetails;        
        let errors = {};
        let formIsValid = true;
        if(!formdetails["status"]){
            formIsValid = false;
            errors["status"] = "Select By";
          }
          this.setState({errors: errors});
          return formIsValid;                 
     }   
     contactSubmit(e){
        e.preventDefault();        
        if(this.handleValidation()){    
          const Axios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
          });
          const loginToken = ls.get('loginToken');
          Axios.defaults.headers.common['Authorization'] = 'bearer '+loginToken;         
          const data = this.state.formdetails;
          const formData = new FormData();               
          formData.append('data', JSON.stringify(data));
          if(data["tsstatus"] === '2'){
          formData.append("apppdf", this.state.savefile);  
          }
          Axios.post(`${process.env.REACT_APP_API_URL}partworks/savepartworkdtp`, formData) 
            .then((responce) => { 
              const result = responce.data;
              if(result.status === 1){    
                this.getdataafterload();    
                this.refreshvalue();    
                swal({
                  title: result.msg,
                  text: "Data Save Successfully",
                  icon: "success",
                  buttons: true
                })             
            }
            else{
              if(result.status === 401){
              swal("Error", result.message, "error"); 
              }else{
                swal("Error", result.msg, "error"); 
              }              
            }              
            });
        }   
      }      
     async refreshvalue(){ 
        this.setState({formdetails:{'workhead':this.props.children.workhead,'partworkhead':this.props.children.partworkhead,'officecode':this.props.children.officecode}}); 
      }   
      async selecthandleChange(name,e) {
        let formdetails = this.state.formdetails; 
        formdetails[name] = e.value;  
        this.setState({formdetails});        
      }  
      datepickerhandleChange(name,e){
        let formdetails = this.state.formdetails;
        formdetails[name] = e.format('DD-MM-YYYY');
        this.setState({formdetails});
      }       
    render() {
        const today = moment();
        const disableFutureDt = current => {
          return current.isBefore(today)
        }        
        return (
                <div className="box">
                    <div className="box-body">
                        <div className="box-header">
                        <h3 className="box-title">Tender Approval</h3>
                        </div>
            <div className="box-body">	
                    <form onSubmit= {this.contactSubmit.bind(this)}>
                    <div className="col-md-12" >
                    <div className="col-md-4" >
                        <div className="form-group">
                            <label>Tender Notice No.</label>
                            <select name="tenderid" id="tenderid" className="form-control" >
                            </select>
                        </div>		
                    </div>
                    <div className="col-md-4" >
                        <div className="form-group">
                            <label>Approved By</label>
                            <Select 
                                    options={this.state.appstatuslist} 
                                    name="tenappstatus" 
                                    value={this.state.appstatuslist.filter(({value}) => value === this.state.formdetails.tenappstatus)  || ''} 
                                    isClearable
                                    onChange={this.selecthandleChange.bind(this,'tenappstatus')} 
                            />                    
                            <span classNameName="text-red">{this.state.errors["tenappstatus"]}</span>  			
                        </div>		
                    </div>		
                        <div className="col-md-4" >
                            <div className="form-group">
                                <label>Amount Put to Tender</label>
                                <input type="text" name="tendamount" value={this.state.formdetails.tendamount  || ''} onChange={this.hideComponent} className="form-control" />
                                <span classNameName="text-red">{this.state.errors["tendamount"]}</span>
                            </div>		
                        </div>
                        </div>
                        <div className="col-md-12" >
                        <div className="col-md-4" >
                            <div className="form-group">
                                <label>Tender Approval No./Letter No./ TPC No</label>
                                <input type="text" name="tendappno" value={this.state.formdetails.tendappno  || ''} onChange={this.hideComponent} className="form-control" />
                                <span classNameName="text-red">{this.state.errors["tendappno"]}</span>
                            </div>		
                        </div>
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Tender Approval Date / TPC Date</label>
                                <DatePicker 
                                    timeFormat={false}
                                    onChange={this.datepickerhandleChange.bind(this,'tendappdate')}
                                    dateFormat="DD-MM-YYYY" 
                                    value={this.state.formdetails.tendappdate || ''}
                                    closeOnSelect 
                                    isValidDate={disableFutureDt}
                                    inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                />
                                <span classNameName="text-red">{this.state.errors["tendappdate"]}</span> 						
                                </div>		
                            </div>	
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Accepted Contract Price</label>
                                    <input type="text" name="acccontprize" value={this.state.formdetails.acccontprize  || ''} onChange={this.hideComponent} className="form-control" />
                                    <span classNameName="text-red">{this.state.errors["acccontprize"]}</span>
                                </div>		
                            </div>	
                            </div>
                            <div className="col-md-12" >	
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>% Above or Below</label>
                                    <input type="text" name="perbelow" value={this.state.formdetails.perbelow  || ''} onChange={this.hideComponent} className="form-control" />
                                    <span classNameName="text-red">{this.state.errors["perbelow"]}</span>
                                </div>		
                            </div>	
                        <div className="col-md-4" >
                            <div className="form-group">
                                <label>SubDivision Office</label>
                                <select name="subdivisionoffice" className="form-control">
                                </select>
                                <span classNameName="text-red">{this.state.errors["subdivisionoffice"]}</span> 
                            </div>		
                        </div>		
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Phone No</label>
                                    <input type="text" name="engphoneno" className="form-control" value={this.state.formdetails.engphoneno  || ''} onChange={this.hideComponent}  />						
                                    <span classNameName="text-red">{this.state.errors["engphoneno"]}</span> 
                                </div>		
                            </div>	
                            </div>
                            <div className="col-md-12" >	
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Name of Contractor</label>
                                    <input type="text" className="form-control" disabled  value={this.state.formdetails.agencyname  || ''} />
                                </div>		
                            </div>				
                        <div className="col-md-4" >
                            <div className="form-group">
                                <label>Upload PDF</label>
                                <input type="file" name="apppdf" value={this.state.formdetails.apppdf  || ''} onChange={this.hideComponent} />
                                <span classNameName="text-red">{this.state.errors["apppdf"]}</span> 
                            </div>		
                        </div>				
                    </div>
                    <div className="col-md-12" >
                    <div className="col-md-6" >
                    <input type="submit" className="btn btn-primary" value="Save" />
                    </div>
                    </div>	
                </form>	   
            <h5 className="text-center">List Tender Approval</h5>    
            <div className="col-md-12 table-responsive">
                <table className="table table-bordered">	
                    <tr className="bg-gray">
                        <th className="text-center">Tender Notice No</th>
                        <th className="text-center">Approved By</th>
                        <th className="text-center">Amount Put to Tender</th>
                        <th className="text-center">Approval No.</th>
                        <th className="text-center">Approval Date</th>
                        <th className="text-center">Accepted Contract Price</th>
                        <th className="text-center">% Above or Below</th>
                        <th className="text-center">Name of Contractor</th>
                        <th className="text-center">Sub Division Office</th>
                        <th className="text-center">Approval File</th>
                        <th className="text-center">Edit</th>
                        <th className="text-center">Delete</th>
                    </tr>
                </table>
            </div>		
            </div>				
            <div className="box-header">
            <h2>Informing Contractor</h2>
            </div>
            <div className="box-body">	
                    <form>
                    <div className="col-md-12" >
                    <div className="col-md-4" >
                        <div className="form-group">
                            <label>Tender Notice No.</label>
                            <select name="tenderid" id="ctenderid" className="form-control">
                            </select>
                        </div>		
                    </div>
                        <div className="col-md-4" >
                            <div className="form-group">
                                <label>LOI NO.</label>
                                <input type="text" name="tendletternoloi" className="form-control" value={this.state.formdetails.tendletternoloi  || ''} onChange={this.hideComponent} />
                                <span classNameName="text-red">{this.state.errors["tendletternoloi"]}</span> 	
                            </div>		
                        </div>
                        <div className="col-md-4" >
                            <div className="form-group">
                                <label>LOI Date</label>
                                <DatePicker 
                                    timeFormat={false}
                                    onChange={this.datepickerhandleChange.bind(this,'tendaccpdateloi')}
                                    dateFormat="DD-MM-YYYY" 
                                    value={this.state.formdetails.tendaccpdateloi || ''}
                                    closeOnSelect 
                                    isValidDate={disableFutureDt}
                                    inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                />
                                <span classNameName="text-red">{this.state.errors["tendaccpdateloi"]}</span> 					
                            </div>		
                        </div>
                        </div>
                        <div className="col-md-12" >
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Tender Acceptance Letter No .</label>
                                    <input type="text" name="tendletterno" className="form-control"  value={this.state.formdetails.tendletterno  || ''} onChange={this.hideComponent} />
                                    <span classNameName="text-red">{this.state.errors["tendletterno"]}</span> 	
                                </div>		
                            </div>	
                            <div className="col-md-4" >
                                <div className="form-group">
                                    <label>Tender Acceptance Letter Date</label>
                                    <DatePicker 
                                        timeFormat={false}
                                        onChange={this.datepickerhandleChange.bind(this,'tendaccpdate')}
                                        dateFormat="DD-MM-YYYY" 
                                        value={this.state.formdetails.tendaccpdate || ''}
                                        closeOnSelect 
                                        isValidDate={disableFutureDt}
                                        inputProps={{placeholder: 'DD-MM-YYYY', readOnly:true}}
                                    />
                                    <span classNameName="text-red">{this.state.errors["tendaccpdate"]}</span> 						
                                </div>		
                            </div>		
                    </div>
                    <div className="col-md-12" >
                    <div className="col-md-6" >
                    <input type="submit" className="btn btn-primary" value="Save" />
                    </div>
                    </div>	
                </form>		   
            <h5 className="text-center">List Informing Contractor</h5> 
            <div className="col-md-12 table-responsive">
                <table className="table table-bordered">	
                    <tr className="bg-gray">
                        <th className="text-center">Tender Notice No.</th>
                        <th className="text-center">LOI No .</th>
                        <th className="text-center">LOI Date</th>
                        <th className="text-center">Tender Acceptance Letter No .</th>
                        <th className="text-center">Tender Acceptance Letter Date</th>
                        <th className="text-center">Edit</th>
                        <th className="text-center">Delete</th>
                    </tr>
                </table>
            </div>		
            </div>				
                    </div>
                </div>	
        )
    }
}

export default Tenderapproval
